import { connect } from 'react-redux'
import * as actions from './actions'
import { logoutRequestResult, shouldRedirectUser, shouldRedirectUserToLogin } from '../../layouts/LoggedIn/actions'
import Login from './Login'

const mapStateToProps = (state, ownProps) => {
  return {
    isLoggingIn: state.login.isLoggingIn,
    loginStatus: state.login.loginStatus,
    user: state.login.user,
    hasErrorOccured: state.login.hasErrorOccured,
    errors: state.login.errors,
    forgetPassError: state.login.forgetPassError,
    shouldResetPassword: state.login.shouldResetPassword,
    maxAttempt: state.login.maxAttempt,
    ...ownProps
  }
}

const mapDispatchToProps = dispatch => ({
  loginUser: (email, password, remember) =>
    dispatch(actions.loginUser(email, password, remember)),
  resetPassword: email => dispatch(actions.resetPassword(email)),
  setShouldResetPassword: bool =>
    dispatch(actions.setShouldResetPassword(bool)),
  logoutRequestResult: bool => dispatch(logoutRequestResult(bool)),
  shouldRedirectUser: bool => dispatch(shouldRedirectUser(bool)),
  shouldRedirectUserToLogin: bool => dispatch(shouldRedirectUserToLogin(bool)),
  authErrors: errors => dispatch(actions.authErrors(errors)),
  resetLoginAttempt: () => dispatch(actions.setMaxLoginAttempt(false)),
  resetError: () => dispatch(actions.resetError())
})

const LoginContainer = connect(mapStateToProps, mapDispatchToProps)(Login)

export default LoginContainer



// WEBPACK FOOTER //
// src/routes/Login/LoginContainer.js